const DEV_DOMAIN = 'dev.doctornow.co.kr';

export const checkDomain = () => {
  return window.location.hostname.includes(DEV_DOMAIN) ? 'DEV' : 'PRODUCTION';
};
